import { useContext } from 'react';
import AppContext from '../../../AppContext';
import { DollarFormat } from '../../format';
import ComparisonOfPoliciesRowData from './ComparisonOfPoliciesRowData';
import RowHelmet from '../RowHelmet';
import styles from './ComparisonOfPoliciesRow.module.css';

export default function ComparisonOfPoliciesRow({
  sectionKey,
  rowKey,
  label,
  currentYearIndividual,
  currentYearGroup,
  previousYearIndividual,
  previousYearGroup,
  priorYearMinusOneIndividual,
  priorYearMinusOneGroup
}: ComparisonOfPoliciesRowData) {
  const { showBenchmark } = useContext(AppContext);
  const id = `${sectionKey}-${rowKey}`;
  return (
    <div
      id={id}
      data-testid={id}
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}>
      <RowHelmet label={label} />
      <p></p>
      <p></p>
      <DollarFormat {...currentYearIndividual} />
      <DollarFormat {...currentYearGroup} />
      <DollarFormat {...previousYearIndividual} />
      <DollarFormat {...previousYearGroup} />
      <DollarFormat {...priorYearMinusOneIndividual} />
      <DollarFormat {...priorYearMinusOneGroup} />
    </div>
  );
}
